import { render, staticRenderFns } from "./CardPendingDocumentation.vue?vue&type=template&id=42e17c42&scoped=true"
import script from "./CardPendingDocumentation.vue?vue&type=script&lang=js"
export * from "./CardPendingDocumentation.vue?vue&type=script&lang=js"
import style0 from "./CardPendingDocumentation.vue?vue&type=style&index=0&id=42e17c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e17c42",
  null
  
)

export default component.exports